import { SpecializedRoles, SystemRoles, userManagementUrl } from '../../../../../constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Accounts, Users } from '../../../../../constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IRevokeSpecializedRolesToAccountUserRequest } from '../specialized-roles/dtos/requests/revoke-roles-to-account-user.request';
import { IAssignSpecializedRolesToAccountUserRequest } from '../specialized-roles/dtos/requests/assign-roles-to-account-user.request';

import { IUpdateAccountUserResponse } from '../dtos/responses/update-account-user-response';
import { ICreateAccountUserRequest } from '../dtos/requests/create-account-user.request';
import { IUpdateUserRequest } from '../dtos/requests/update-account-user.request';
import { AccountUsersListApiResponse } from '../dtos/responses/account-user-response';
import { IChangeAccountUserPasswordRequest } from '../dtos/requests/change-password-account-user.request';
import { UserContextService } from '../../../auth-management/authentication/services/user-context.service';
import { DeprecatedPaginationParameters } from '../../../../../trash/shared/interfaces/shared-interfaces';
@Injectable({
  providedIn: 'root'
})
export class AccountUserService {
  userContext = UserContextService.getUserContext();
  collectionUrl: string = `${userManagementUrl}/${Accounts}/${this.userContext?.accountId}/${Users}`;

  constructor(private http: HttpClient) {}

  getAll(params?: DeprecatedPaginationParameters): Observable<AccountUsersListApiResponse> {
    let paramsItem = new HttpParams();

    // Loop through the parameters and append them if defined
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== undefined && value !== null && value !== '') {
          paramsItem = paramsItem.append(this.mapParamKey(key), value);
        }
      });
    }

    // Return the HTTP GET call with the expected response type
    return this.http.get<AccountUsersListApiResponse>(`${this.collectionUrl}`, { params: paramsItem });
  }
  // Helper method to map parameter keys if needed (optional)
  private mapParamKey(key: string): string {
    const map: { [key: string]: string } = {
      sortColumn: 'SortColumn',
      sortOrder: 'SortOrder',
      searchField: 'SearchField',
      SearchKeyword: 'SearchKeyword',
      page: 'Page',
      pageSize: 'PageSize',
      order: 'Order',
      orderBy: 'OrderBy'
    };
    return map[key] || key;
  }

  // Create a new resource (POST)
  async create(request: ICreateAccountUserRequest): Promise<Observable<AccountUsersListApiResponse>> {
    return await this.http.post<AccountUsersListApiResponse>(`${this.collectionUrl}`, request);
  }

  // Update a resource (PUT)
  async update(request: IUpdateUserRequest, id: number | string): Promise<Observable<IUpdateAccountUserResponse>> {
    return await this.http.put<IUpdateAccountUserResponse>(`${this.collectionUrl}/${id}`, request);
  }

  getAllSysyemRoles(params?: DeprecatedPaginationParameters): Observable<any> {
    let paramsItem = new HttpParams();

    // Loop through the parameters and append them if defined
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== undefined && value !== null && value !== '') {
          paramsItem = paramsItem.append(this.mapParamKey(key), value);
        }
      });
    }

    // Return the HTTP GET call with the expected response type
    return this.http.get<any>(`${userManagementUrl}/${SystemRoles}`, { params: paramsItem });
  }

  getAllSpecializedRoles(params?: DeprecatedPaginationParameters): Observable<any> {
    let paramsItem = new HttpParams();

    // Loop through the parameters and append them if defined
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== undefined && value !== null && value !== '') {
          paramsItem = paramsItem.append(this.mapParamKey(key), value);
        }
      });
    }

    // Return the HTTP GET call with the expected response type
    return this.http.get<any>(
      `${userManagementUrl}/${Accounts}/${UserContextService.getUserContext()!.accountId}/${SpecializedRoles}`,
      { params: paramsItem }
    );
  }

  // Assign Specialized Roles(POST)
  async AssignSpecializedRolesToAccountUser(
    request: IAssignSpecializedRolesToAccountUserRequest,
    id: number | string
  ): Promise<Observable<any>> {
    return await this.http.post<any>(`${this.collectionUrl}/${id}/specialized-roles`, request);
  }

  // Revoke Specialized Roles(DELETE)
  async RevokeSpecializedRolesToAccountUser(
    request: IRevokeSpecializedRolesToAccountUserRequest,
    id: number | string
  ): Promise<Observable<any>> {
    return await this.http.delete<any>(`${this.collectionUrl}/${id}/specialized-roles`, {
      body: request
    });
  }

  // Change Password(PATCH)
  async ChangePasswordAccountUser(
    request: IChangeAccountUserPasswordRequest,
    id: number | string
  ): Promise<Observable<any>> {
    return await this.http.patch<any>(`${this.collectionUrl}/${id}/change-password`, request);
  }

  // Get a single resource by ID (GET)
  // getById(id: string): Observable<TResponse> {
  //   return this.http.get<TResponse>(`${this.baseUrl}/${this.collectionName}/${id}`);
  // }

  // Delete a single resource by ID (DELETE)
  // delete(id: string): Observable<void> {
  //   return this.http.delete<void>(`${this.baseUrl}/${this.collectionName}/${id}`);
  // }
}
